export type CountryPrefix = {
  iso2: string;
  code: string;
  label: string;
};

export const COUNTRY_PREFIXES: CountryPrefix[] = [
  { iso2: "ES", code: "+34", label: "España" },
  { iso2: "MX", code: "+52", label: "México" },
  { iso2: "AR", code: "+54", label: "Argentina" },
  { iso2: "CO", code: "+57", label: "Colombia" },
  { iso2: "PE", code: "+51", label: "Perú" },
  { iso2: "CL", code: "+56", label: "Chile" },
  { iso2: "EC", code: "+593", label: "Ecuador" },
  { iso2: "VE", code: "+58", label: "Venezuela" },
  { iso2: "BO", code: "+591", label: "Bolivia" },
  { iso2: "PY", code: "+595", label: "Paraguay" },
  { iso2: "UY", code: "+598", label: "Uruguay" },
  { iso2: "BR", code: "+55", label: "Brasil" },
  { iso2: "GT", code: "+502", label: "Guatemala" },
  { iso2: "SV", code: "+503", label: "El Salvador" },
  { iso2: "HN", code: "+504", label: "Honduras" },
  { iso2: "NI", code: "+505", label: "Nicaragua" },
  { iso2: "CR", code: "+506", label: "Costa Rica" },
  { iso2: "PA", code: "+507", label: "Panamá" },
  { iso2: "CU", code: "+53", label: "Cuba" },
  { iso2: "US", code: "+1", label: "Estados Unidos" },
  { iso2: "CA", code: "+1", label: "Canadá" },
  { iso2: "PR", code: "+1", label: "Puerto Rico" },
  { iso2: "DO", code: "+1", label: "República Dominicana" },
  { iso2: "JM", code: "+1", label: "Jamaica" },
  { iso2: "TT", code: "+1", label: "Trinidad y Tobago" },
  { iso2: "BS", code: "+1", label: "Bahamas" },
  { iso2: "BB", code: "+1", label: "Barbados" },
  { iso2: "AG", code: "+1", label: "Antigua y Barbuda" },
  { iso2: "AI", code: "+1", label: "Anguila" },
  { iso2: "BM", code: "+1", label: "Bermudas" },
  { iso2: "VG", code: "+1", label: "Islas Vírgenes Británicas" },
  { iso2: "VI", code: "+1", label: "Islas Vírgenes de EE.UU." },
  { iso2: "KY", code: "+1", label: "Islas Caimán" },
  { iso2: "DM", code: "+1", label: "Dominica" },
  { iso2: "GD", code: "+1", label: "Granada" },
  { iso2: "GU", code: "+1", label: "Guam" },
  { iso2: "MS", code: "+1", label: "Montserrat" },
  { iso2: "MP", code: "+1", label: "Islas Marianas del Norte" },
  { iso2: "KN", code: "+1", label: "San Cristóbal y Nieves" },
  { iso2: "LC", code: "+1", label: "Santa Lucía" },
  { iso2: "VC", code: "+1", label: "San Vicente y las Granadinas" },
  { iso2: "SX", code: "+1", label: "Sint Maarten" },
  { iso2: "TC", code: "+1", label: "Islas Turcas y Caicos" },
  { iso2: "GB", code: "+44", label: "Reino Unido" },
  { iso2: "IE", code: "+353", label: "Irlanda" },
  { iso2: "FR", code: "+33", label: "Francia" },
  { iso2: "DE", code: "+49", label: "Alemania" },
  { iso2: "IT", code: "+39", label: "Italia" },
  { iso2: "PT", code: "+351", label: "Portugal" },
  { iso2: "NL", code: "+31", label: "Países Bajos" },
  { iso2: "BE", code: "+32", label: "Bélgica" },
  { iso2: "LU", code: "+352", label: "Luxemburgo" },
  { iso2: "CH", code: "+41", label: "Suiza" },
  { iso2: "AT", code: "+43", label: "Austria" },
  { iso2: "DK", code: "+45", label: "Dinamarca" },
  { iso2: "SE", code: "+46", label: "Suecia" },
  { iso2: "NO", code: "+47", label: "Noruega" },
  { iso2: "FI", code: "+358", label: "Finlandia" },
  { iso2: "IS", code: "+354", label: "Islandia" },
  { iso2: "PL", code: "+48", label: "Polonia" },
  { iso2: "CZ", code: "+420", label: "Chequia" },
  { iso2: "SK", code: "+421", label: "Eslovaquia" },
  { iso2: "HU", code: "+36", label: "Hungría" },
  { iso2: "RO", code: "+40", label: "Rumanía" },
  { iso2: "BG", code: "+359", label: "Bulgaria" },
  { iso2: "GR", code: "+30", label: "Grecia" },
  { iso2: "CY", code: "+357", label: "Chipre" },
  { iso2: "MT", code: "+356", label: "Malta" },
  { iso2: "SI", code: "+386", label: "Eslovenia" },
  { iso2: "HR", code: "+385", label: "Croacia" },
  { iso2: "BA", code: "+387", label: "Bosnia y Herzegovina" },
  { iso2: "RS", code: "+381", label: "Serbia" },
  { iso2: "ME", code: "+382", label: "Montenegro" },
  { iso2: "XK", code: "+383", label: "Kosovo" },
  { iso2: "MK", code: "+389", label: "Macedonia del Norte" },
  { iso2: "AL", code: "+355", label: "Albania" },
  { iso2: "MD", code: "+373", label: "Moldavia" },
  { iso2: "UA", code: "+380", label: "Ucrania" },
  { iso2: "BY", code: "+375", label: "Bielorrusia" },
  { iso2: "RU", code: "+7", label: "Rusia" },
  { iso2: "EE", code: "+372", label: "Estonia" },
  { iso2: "LV", code: "+371", label: "Letonia" },
  { iso2: "LT", code: "+370", label: "Lituania" },
  { iso2: "AX", code: "+358", label: "Islas Åland" },
  { iso2: "LI", code: "+423", label: "Liechtenstein" },
  { iso2: "MC", code: "+377", label: "Mónaco" },
  { iso2: "AD", code: "+376", label: "Andorra" },
  { iso2: "SM", code: "+378", label: "San Marino" },
  { iso2: "VA", code: "+379", label: "Ciudad del Vaticano" },
  { iso2: "FO", code: "+298", label: "Islas Feroe" },
  { iso2: "GI", code: "+350", label: "Gibraltar" },
  { iso2: "GL", code: "+299", label: "Groenlandia" },
  { iso2: "SJ", code: "+47", label: "Svalbard y Jan Mayen" },
  { iso2: "IM", code: "+44", label: "Isla de Man" },
  { iso2: "JE", code: "+44", label: "Jersey" },
  { iso2: "GG", code: "+44", label: "Guernsey" },
  { iso2: "MA", code: "+212", label: "Marruecos" },
  { iso2: "EH", code: "+212", label: "Sáhara Occidental" },
  { iso2: "DZ", code: "+213", label: "Argelia" },
  { iso2: "TN", code: "+216", label: "Túnez" },
  { iso2: "LY", code: "+218", label: "Libia" },
  { iso2: "EG", code: "+20", label: "Egipto" },
  { iso2: "SD", code: "+249", label: "Sudán" },
  { iso2: "SS", code: "+211", label: "Sudán del Sur" },
  { iso2: "MR", code: "+222", label: "Mauritania" },
  { iso2: "ML", code: "+223", label: "Malí" },
  { iso2: "SN", code: "+221", label: "Senegal" },
  { iso2: "GM", code: "+220", label: "Gambia" },
  { iso2: "GN", code: "+224", label: "Guinea" },
  { iso2: "GW", code: "+245", label: "Guinea-Bisáu" },
  { iso2: "SL", code: "+232", label: "Sierra Leona" },
  { iso2: "LR", code: "+231", label: "Liberia" },
  { iso2: "CI", code: "+225", label: "Costa de Marfil" },
  { iso2: "GH", code: "+233", label: "Ghana" },
  { iso2: "TG", code: "+228", label: "Togo" },
  { iso2: "BJ", code: "+229", label: "Benín" },
  { iso2: "BF", code: "+226", label: "Burkina Faso" },
  { iso2: "NE", code: "+227", label: "Níger" },
  { iso2: "NG", code: "+234", label: "Nigeria" },
  { iso2: "CM", code: "+237", label: "Camerún" },
  { iso2: "TD", code: "+235", label: "Chad" },
  { iso2: "CF", code: "+236", label: "República Centroafricana" },
  { iso2: "GQ", code: "+240", label: "Guinea Ecuatorial" },
  { iso2: "GA", code: "+241", label: "Gabón" },
  { iso2: "CG", code: "+242", label: "Congo" },
  { iso2: "CD", code: "+243", label: "República Democrática del Congo" },
  { iso2: "AO", code: "+244", label: "Angola" },
  { iso2: "ST", code: "+239", label: "Santo Tomé y Príncipe" },
  { iso2: "CV", code: "+238", label: "Cabo Verde" },
  { iso2: "ET", code: "+251", label: "Etiopía" },
  { iso2: "ER", code: "+291", label: "Eritrea" },
  { iso2: "DJ", code: "+253", label: "Yibuti" },
  { iso2: "SO", code: "+252", label: "Somalia" },
  { iso2: "KE", code: "+254", label: "Kenia" },
  { iso2: "UG", code: "+256", label: "Uganda" },
  { iso2: "TZ", code: "+255", label: "Tanzania" },
  { iso2: "RW", code: "+250", label: "Ruanda" },
  { iso2: "BI", code: "+257", label: "Burundi" },
  { iso2: "MZ", code: "+258", label: "Mozambique" },
  { iso2: "MW", code: "+265", label: "Malaui" },
  { iso2: "ZM", code: "+260", label: "Zambia" },
  { iso2: "ZW", code: "+263", label: "Zimbabue" },
  { iso2: "BW", code: "+267", label: "Botsuana" },
  { iso2: "NA", code: "+264", label: "Namibia" },
  { iso2: "ZA", code: "+27", label: "Sudáfrica" },
  { iso2: "LS", code: "+266", label: "Lesoto" },
  { iso2: "SZ", code: "+268", label: "Esuatini" },
  { iso2: "MG", code: "+261", label: "Madagascar" },
  { iso2: "MU", code: "+230", label: "Mauricio" },
  { iso2: "SC", code: "+248", label: "Seychelles" },
  { iso2: "KM", code: "+269", label: "Comoras" },
  { iso2: "RE", code: "+262", label: "Reunión" },
  { iso2: "YT", code: "+262", label: "Mayotte" },
  { iso2: "SH", code: "+290", label: "Santa Elena" },
  { iso2: "SH", code: "+247", label: "Ascensión" },
  { iso2: "SH", code: "+290", label: "Tristán de Acuña" },
  { iso2: "TR", code: "+90", label: "Turquía" },
  { iso2: "IL", code: "+972", label: "Israel" },
  { iso2: "PS", code: "+970", label: "Palestina" },
  { iso2: "JO", code: "+962", label: "Jordania" },
  { iso2: "LB", code: "+961", label: "Líbano" },
  { iso2: "SY", code: "+963", label: "Siria" },
  { iso2: "IQ", code: "+964", label: "Irak" },
  { iso2: "IR", code: "+98", label: "Irán" },
  { iso2: "SA", code: "+966", label: "Arabia Saudí" },
  { iso2: "YE", code: "+967", label: "Yemen" },
  { iso2: "OM", code: "+968", label: "Omán" },
  { iso2: "AE", code: "+971", label: "Emiratos Árabes Unidos" },
  { iso2: "QA", code: "+974", label: "Catar" },
  { iso2: "BH", code: "+973", label: "Baréin" },
  { iso2: "KW", code: "+965", label: "Kuwait" },
  { iso2: "AM", code: "+374", label: "Armenia" },
  { iso2: "AZ", code: "+994", label: "Azerbaiyán" },
  { iso2: "GE", code: "+995", label: "Georgia" },
  { iso2: "CN", code: "+86", label: "China" },
  { iso2: "HK", code: "+852", label: "Hong Kong" },
  { iso2: "MO", code: "+853", label: "Macao" },
  { iso2: "TW", code: "+886", label: "Taiwán" },
  { iso2: "JP", code: "+81", label: "Japón" },
  { iso2: "KR", code: "+82", label: "Corea del Sur" },
  { iso2: "KP", code: "+850", label: "Corea del Norte" },
  { iso2: "MN", code: "+976", label: "Mongolia" },
  { iso2: "IN", code: "+91", label: "India" },
  { iso2: "PK", code: "+92", label: "Pakistán" },
  { iso2: "BD", code: "+880", label: "Bangladés" },
  { iso2: "LK", code: "+94", label: "Sri Lanka" },
  { iso2: "NP", code: "+977", label: "Nepal" },
  { iso2: "BT", code: "+975", label: "Bután" },
  { iso2: "MV", code: "+960", label: "Maldivas" },
  { iso2: "AF", code: "+93", label: "Afganistán" },
  { iso2: "IO", code: "+246", label: "Territorio Británico del Océano Índico" },
  { iso2: "KZ", code: "+7", label: "Kazajistán" },
  { iso2: "KG", code: "+996", label: "Kirguistán" },
  { iso2: "TJ", code: "+992", label: "Tayikistán" },
  { iso2: "TM", code: "+993", label: "Turkmenistán" },
  { iso2: "UZ", code: "+998", label: "Uzbekistán" },
  { iso2: "MM", code: "+95", label: "Myanmar" },
  { iso2: "TH", code: "+66", label: "Tailandia" },
  { iso2: "LA", code: "+856", label: "Laos" },
  { iso2: "KH", code: "+855", label: "Camboya" },
  { iso2: "VN", code: "+84", label: "Vietnam" },
  { iso2: "MY", code: "+60", label: "Malasia" },
  { iso2: "SG", code: "+65", label: "Singapur" },
  { iso2: "ID", code: "+62", label: "Indonesia" },
  { iso2: "PH", code: "+63", label: "Filipinas" },
  { iso2: "BN", code: "+673", label: "Brunéi" },
  { iso2: "TL", code: "+670", label: "Timor Oriental" },
  { iso2: "AU", code: "+61", label: "Australia" },
  { iso2: "CX", code: "+61", label: "Isla de Navidad" },
  { iso2: "CC", code: "+61", label: "Islas Cocos" },
  { iso2: "NF", code: "+672", label: "Isla Norfolk" },
  { iso2: "NZ", code: "+64", label: "Nueva Zelanda" },
  { iso2: "PN", code: "+64", label: "Islas Pitcairn" },
  { iso2: "PG", code: "+675", label: "Papúa Nueva Guinea" },
  { iso2: "FJ", code: "+679", label: "Fiyi" },
  { iso2: "SB", code: "+677", label: "Islas Salomón" },
  { iso2: "VU", code: "+678", label: "Vanuatu" },
  { iso2: "NC", code: "+687", label: "Nueva Caledonia" },
  { iso2: "PF", code: "+689", label: "Polinesia Francesa" },
  { iso2: "WS", code: "+685", label: "Samoa" },
  { iso2: "AS", code: "+1", label: "Samoa Americana" },
  { iso2: "TO", code: "+676", label: "Tonga" },
  { iso2: "KI", code: "+686", label: "Kiribati" },
  { iso2: "TV", code: "+688", label: "Tuvalu" },
  { iso2: "NR", code: "+674", label: "Nauru" },
  { iso2: "PW", code: "+680", label: "Palaos" },
  { iso2: "FM", code: "+691", label: "Micronesia" },
  { iso2: "MH", code: "+692", label: "Islas Marshall" },
  { iso2: "CK", code: "+682", label: "Islas Cook" },
  { iso2: "NU", code: "+683", label: "Niue" },
  { iso2: "TK", code: "+690", label: "Tokelau" },
  { iso2: "WF", code: "+681", label: "Wallis y Futuna" },
  { iso2: "BZ", code: "+501", label: "Belice" },
  { iso2: "GY", code: "+592", label: "Guyana" },
  { iso2: "SR", code: "+597", label: "Surinam" },
  { iso2: "GF", code: "+594", label: "Guayana Francesa" },
  { iso2: "FK", code: "+500", label: "Islas Malvinas" },
  { iso2: "AW", code: "+297", label: "Aruba" },
  { iso2: "CW", code: "+599", label: "Curazao" },
  { iso2: "BQ", code: "+599", label: "Caribe Neerlandés" },
  { iso2: "HT", code: "+509", label: "Haití" },
  { iso2: "BL", code: "+590", label: "San Bartolomé" },
  { iso2: "MF", code: "+590", label: "San Martín" },
  { iso2: "PM", code: "+508", label: "San Pedro y Miquelón" },
  { iso2: "GP", code: "+590", label: "Guadalupe" },
  { iso2: "MQ", code: "+596", label: "Martinica" },
];
